module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "u-relative u-flex u-flex-ai--center u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--2__container u-marg-x-auto u-flex u-flex-ai--center u-flex-jc--center u-w10of12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--2__container__right-side u-w1of2 u-w3of4@sm"
  }, [_c('div', {
    staticClass: "c-home-slide--2__container__right-side__wrapper"
  }, [_c('app-home-slide-nb-title', {
    staticClass: "c-home-slide__element has-delay-1",
    attrs: {
      "index": 1,
      "number": "01",
      "label": "PRAX",
      "color": "black"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--2__container__left-side c-home-slide__element has-delay-0 u-flex u-flex-ai--start u-flex-jc--center u-w1of2"
  }, [_c('img', {
    staticClass: "c-home-slide--2__image u-w3of5",
    attrs: {
      "src": "/static/images/prax-logotype-blue_2.png",
      "alt": "PRAX",
      "title": "PRAX"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "c-home-slide--2__title c-home-slide__element has-delay-2 t-fweight--light u-color--gray-darker u-lheight--125p"
  }, [_c('div', {
    staticClass: "c-home-slide--2__title--1 u-relative"
  }, [_vm._v("Earn PRAX,")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--2__title--2 u-relative u-flex u-flex-ai--center u-fit-w"
  }, [_c('span', {
    staticClass: "c-home-slide--2__title--2__line"
  }), _vm._v(" "), _c('span', {
    staticClass: "u-marg-l-sm u-color--brand-primary"
  }, [_vm._v("use PRAX")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-home-slide--2__description c-home-slide__element has-delay-3 o-content u-lheight--150p u-color--black u-force-3d"
  }, [_c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("In the beginning of blockchain, bitcoin could be earned in the thousands a day by mining with a personal computer. Now, the incentives have grown to support much more specialized equipment making it the most powerful computing network in the world.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "u-opacity--40"
  }, [_vm._v("We have similar plans for PRAX will continue to add innovative uses that increase demand. As the uses grow, the incentives will too, bringing user growth and a need for better equipment. Drones, cars, satellites, and many other devices can and will contribute to this repository.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d749e39"}!./src/scripts/components/app-home-slide-2/template.html
// module id = 477
// module chunks = 0